
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-search-page",
      function () {
        return require("private-next-pages/job-search-page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-search-page"])
      });
    }
  